import React from 'react';
import CookieConsent from "react-cookie-consent";

function HeroHome() {
    return (
        <section className="relative w-full h-screen overflow-hidden z-20">
            <div
                className="absolute inset-0 pointer-events-none"
                aria-hidden="true"
                style={{
                    background:
                        "linear-gradient(to bottom, rgba(0,0,0,0.85), rgba(0,0,0,0.4), rgba(0,0,0,0.6))",
                }}
            />

            <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 h-full flex flex-col">
                <CookieConsent
                    enableDeclineButton
                    style={{
                        background: "rgba(0,0,0,0.85)",
                        color: "#ffffff",
                        fontSize: "0.875rem",
                    }}
                    buttonStyle={{
                        background: "#ffffff",
                        color: "#000000",
                        borderRadius: "9999px",
                        padding: "8px 16px",
                        fontSize: "0.875rem",
                        fontWeight: 600,
                    }}
                    declineButtonStyle={{
                        borderRadius: "9999px",
                        padding: "8px 16px",
                        fontSize: "0.875rem",
                        border: "1px solid #ffffff",
                        background: "transparent",
                        color: "#ffffff",
                        fontWeight: 500,
                    }}
                >
                    This website uses cookies to enhance the user experience.
                </CookieConsent>

                {/* Hero content */}
                <div className="flex-1 flex flex-col justify-center items-center text-center">
                    <div className="space-y-6">
                        <img
                            className="mx-auto h-14 sm:h-16 object-contain"
                            data-aos="fade-down"
                            data-aos-duration="1500"
                            src={require('../images/Logo/agmLogoWhite2.png').default}
                            alt="AGM Technologies"
                        />


                        <h1
                            className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-tight max-w-3xl mx-auto"
                            data-aos="fade-up"
                            data-aos-delay="350"
                            data-aos-duration="1500"
                        >
                            A Global Technology &amp; Solutions Provider
                        </h1>

                        <p
                            className="text-sm sm:text-base text-gray-200 max-w-2xl mx-auto"
                            data-aos="fade-up"
                            data-aos-delay="500"
                            data-aos-duration="1500"
                        >
                            AGM Technologies combines intelligent sensing hardware, advanced analytics and flexible platforms to power scalable solutions for insurers, fleets and enterprise partners.
                        </p>

                        {/* CTAs */}
                        <div
                            className="mt-4 flex flex-col sm:flex-row items-center justify-center gap-3"
                            data-aos="fade-up"
                            data-aos-delay="650"
                            data-aos-duration="1500"
                        >
                            <a
                                href="/telematics"
                                className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-gray-400 text-white text-sm sm:text-base font-medium hover:border-white hover:bg-white hover:bg-opacity-5 transition duration-150 ease-in-out"
                            >
                                Discover our products 
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HeroHome;
